module.exports = __webpack_public_path__ + "img/110078.31434790.png";